<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >वेब एकीकरण </h2>
        </div>
        <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a> 
        </div>
        <div class="col-md-12" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id='19' >
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe class="i-frame" src="https://www.youtube.com/embed/_zlfMu4kmw8"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div>

        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="20">

            <label for="" class="mt-3 " >पे जी ऑनलाइन व्यवसायों और वित्तीय
                पारिस्थितिकी तंत्र के बीच एक महत्वपूर्ण पुल के रूप में कार्य करता है, जो
                सुरक्षित और कुशल ऑनलाइन लेनदेन को सक्षम बनाता है। यह पॉइंट-ऑफ-सेल टर्मिनल के
                आभासी समकक्ष के रूप में कार्य करता है, जो ग्राहक, उनकी चुनी हुई भुगतान विधि
                और व्यापारी के बैंक के बीच भुगतान जानकारी के हस्तांतरण की सुविधा प्रदान करता
                है। इस प्रक्रिया में लेनदेन के दौरान संवेदनशील डेटा की सुरक्षा के लिए
                एन्क्रिप्शन और सुरक्षा उपाय शामिल हैं। </label>
            <label for="" class="mt-4" >वेब एकीकरण भुगतान गेटवे को ऑनलाइन स्टोर
                से जोड़ने की प्रक्रिया है, जिससे व्यवसायों को सुरक्षित रूप से ऑनलाइन भुगतान
                स्वीकार करने की अनुमति मिलती है। इसमें वेबसाइट की चेकआउट प्रक्रिया में
                आवश्यक कोड और एपीआई (एप्लिकेशन प्रोग्रामिंग इंटरफेस) को एम्बेड करना शामिल
                है। एक बार एकीकृत होने के बाद, ग्राहक अपनी पसंदीदा भुगतान विधि का चयन कर
                सकते हैं, और भुगतान गेटवे बाकी काम संभालता है - भुगतान डेटा को सुरक्षित रूप
                से प्रसारित करना, लेनदेन का सत्यापन करना और इसकी सफलता की पुष्टि करना। अब,
                ऑनलाइन भुगतान स्वीकार करना सरल है, प्लग एंड प्ले एकीकरण विकल्पों के लिए
                धन्यवाद। पे जी किसी भी डेवलपर के लिए सबसे आसान समाधान है। इसे किसी भी वेबसाइट
                पर किसी भी स्टैक के साथ एकीकृत किया जा सकता है। हमारे पास सभी प्रमुख
                प्लेटफार्मों के लिए विस्तृत दस्तावेज़ीकरण और एसडीके के साथ सरल भुगतान एपीआई
                हैं। ऑनलाइन भुगतान स्वीकार करना सरल है, प्लग एंड प्ले एकीकरण विकल्पों के लिए
                धन्यवाद। पे जी किसी भी डेवलपर के लिए सबसे आसान समाधान है। इसे किसी भी वेबसाइट
                पर किसी भी स्टैक के साथ एकीकृत किया जा सकता है। हमारे पास सभी प्रमुख
                प्लेटफार्मों के लिए विस्तृत दस्तावेज़ीकरण और एसडीके के साथ सरल भुगतान एपीआई
                हैं। </label>
        </div>
        <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="21">
            <h2 >वेब एकीकरण के लाभ </h2>
            <label for="" class="mt-3" >भुगतान गेटवे कंपनी में वेब एकीकरण कई
                लाभ प्रदान करता है जो व्यवसायों और उनके ग्राहकों दोनों के लिए समग्र दक्षता,
                सुरक्षा और उपयोगकर्ता अनुभव को बढ़ाता है। </label>

            <ul>
                <li class="mt-3" ><b> चेकआउट अनुभव:</b>&nbsp;एकीकरण ग्राहकों के
                    लिए एक सुसंगत और ब्रांडेड चेकआउट अनुभव प्रदान करता है| </li>

                <li class="mt-3" ><b> उन्नत सुरक्षा: </b>&nbsp;वेब एकीकरण यह
                    सुनिश्चित करता है कि भुगतान जानकारी ग्राहक, व्यापारी और पे जी के बीच
                    सुरक्षित रूप से प्रसारित हो। इससे डेटा उल्लंघनों और धोखाधड़ी का जोखिम कम
                    हो जाता है, क्योंकि संवेदनशील डेटा लेनदेन के दौरान एन्क्रिप्ट और
                    संरक्षित होता है। </li>

                <li class="mt-3" ><b> परित्याग में कमी:</b>&nbsp;एक निर्बाध
                    चेकआउट प्रक्रिया कार्ट परित्याग दर को कम कर सकती है, क्योंकि ग्राहकों के
                    निराश होने और छोड़ने की संभावना कम होती है। </li>

                <li class="mt-3" ><b> एकाधिक भुगतान विकल्प: </b>&nbsp;पे जी कई
                    प्रकार की भुगतान विधियों की पेशकश करता है, जैसे क्रेडिट/डेबिट कार्ड,
                    डिजिटल वॉलेट और बैंक हस्तांतरण। वेब एकीकरण व्यवसायों को इन विविध
                    विकल्पों की पेशकश करने, विभिन्न ग्राहकों की प्राथमिकताओं को पूरा करने और
                    बिक्री पूरी करने की संभावनाओं को बढ़ाने की अनुमति देता है।
                </li>

                <li class="mt-3" ><b> वास्तविक समय लेनदेन की
                        निगरानी:</b>&nbsp;एकीकृत भुगतान गेटवे लेनदेन में वास्तविक समय की
                    जानकारी प्रदान करते हैं, जिससे व्यवसायों को बिक्री को ट्रैक करने,
                    रुझानों की पहचान करने और अपने संचालन को अनुकूलित करने के लिए सूचित
                    निर्णय लेने की अनुमति मिलती है।
                </li>

                <li class="mt-3" ><b>मोबाइल-अनुकूल: </b>&nbsp;जैसे-जैसे अधिक
                    ग्राहक मोबाइल उपकरणों पर खरीदारी करते हैं, एकीकृत भुगतान गेटवे अक्सर
                    मोबाइल प्रतिक्रिया के लिए अनुकूलित होते हैं, जिससे सभी उपकरणों पर एक सहज
                    भुगतान अनुभव सुनिश्चित होता है। </li>

            </ul>
        </div>
    </div>
</div>
</div>
<div class="col-md-4   hide-tbl content2 ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                विषयसूची:
            </h5>
        </div>
        <div class="col-md-12 mt-2" >
            <a href="#19">
                <div class="row">
                    <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">

                    
                        <span style="cursor: pointer;" class="videoHover"
                            [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                            >
                            वेब एकीकरण </span>
                    </div>
                </div>
            </a>
        </div>
    
        <div class="col-md-12 mt-2">
            <a href="#20">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">

                       
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            >
                            वेब इंटीग्रेशन क्या है? </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#21">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">

                      
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >वेब एकीकरण के प्रमुख लाभ </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="https://payg.in/developer.html" target="_blank">
                <div class="row">
                    <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                      
                        <span style="cursor: pointer;" class="demoHover"
                            [ngClass]="{'demo':colors=='4'}" (click)="color('4')"
                            >
                            डेवलपर्स </span>
                    </div>
                </div>
            </a>
        </div>


    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
           
            <a [routerLink]="['/e-agrement']">  <button class="btn btn-color" (click)="menues('E-Agreement')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;ई-एग्रीमेंट

            </button></a>
        </div>
        <div class="col-md-4    ">
           
            <a [routerLink]="['/payment-link']"> <button class="btn btn-color" (click)="menues('Payment Link')" >पेमेंट
                लिंक
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
        </div>
    </div>
</div>
</div>